import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

// eslint-disable-next-line import/extensions
import { dotSpacer } from '../../lib/styles/dot-spacer.styles';
import { ReactNode } from 'react';

export const LocationsSectionHeader = styled.h2`
  margin: 0;
  font-weight: ${fromTheme('font_weight_bolder')};
  font-size: ${fromTheme('font_size_heading_4')};
  color: ${fromTheme('color_text')};
`;

export const MapContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'height'
})<{ height?: string | number }>`
  margin: ${fromTheme('spacing_medium')} 0;
  width: 100%;
  padding-top: 33.3%;
  border-radius: ${fromTheme('border_radius_medium')};
  overflow: hidden;
  position: relative;
  ${({ height }) =>
    height != null
      ? `height: ${typeof height === 'string' ? height : `${height}px`};`
      : ''};
`;

export const MapContainerInner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  > div {
    width: 100%;
    height: 100%;
  }
`;

export const MapLoading = styled.div`
  border-radius: 2px;
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: ${fromTheme('color_background_secondary')};
  background: linear-gradient(
    to right,
    ${fromTheme('color_button_secondary')} 10%,
    ${fromTheme('color_background_disabled_form_input')} 18%,
    ${fromTheme('color_button_secondary')} 33%
  );
  background-size: 1000px 640px;
  height: 100%;
  position: relative;
`;

export const LocationsList = styled.ol`
  list-style: none;
  padding: 0;
  counter-reset: item;
  margin-bottom: 0;
`;

export const LocationWrapper = styled.li`
  margin: 0;
  padding: ${fromTheme('spacing_medium')} 0;
  padding-left: ${fromTheme('spacing_large')};
  border-bottom: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_border')};
  counter-increment: item;
  position: relative;

  &:last-child {
    padding-bottom: 0;
  }

  > div:first-of-type {
    font-size: ${fromTheme('font_size')};

    > strong {
      padding-bottom: 0;
    }

    > strong > a,
    > strong {
      font-weight: ${fromTheme('font_weight_bold')};
      padding-top: 0;
    }
  }

  &:before {
    content: counter(item);
    font-size: ${fromTheme('font_size')};
    font-weight: ${fromTheme('font_weight_bolder')};
    color: ${fromTheme('color_text')};
    position: absolute;
    left: 4px;
    top: ${fromTheme('spacing_medium')};
  }

  &:last-of-type {
    border-bottom: none;
  }
`;

export const LocationRow = styled('ul')`
  padding: 0 0 ${fromTheme('spacing_small')} 0;
  font-size: ${fromTheme('font_size')};
  color: ${fromTheme('color_text')};
  display: flex;
  flex-wrap: wrap;

  &:first-of-type {
    padding-top: ${fromTheme('spacing_small')};
  }

  > li {
    list-style: none;
    &:not(:first-of-type):before {
      ${(props: any) =>
        dotSpacer({
          marginLeft: fromTheme('spacing_small')(props),
          marginRight: fromTheme('spacing_small')(props)
        })}
    }
  }

  &:last-of-type {
    padding-bottom: 0px;
    @media only screen and (max-width: ${fromTheme('screen_medium')}) {
      margin-top: ${fromTheme('spacing_small')};
    };
  }
}
`;

export const LocationInfoItem = styled.span<{
  children?: ReactNode;
  noPrint?: boolean;
}>`
  list-style: none;
  margin: 0;
  color: ${fromTheme('color_text')};

  .contact-label {
    text-transform: capitalize;
  }

  ${({ noPrint }: any) =>
    noPrint &&
    `@media print {
      display: none;
    }`}
`;

export const LocationPhoneAnchor = styled.a`
  color: ${fromTheme('color_link')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const LocationAddressRow = styled('span')`
  font-size: ${fromTheme('font_size')};
  color: ${fromTheme('color_text')};
  line-height: 1.6;
`;

export const LocationHeaderContainer = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  > *:last-child {
    margin-right: 0;
  }
`;
